import styled from 'styled-components'

export const Section = styled.section`
  margin: 15px;
  &:first-child {
    margin: 1em;
  }
`
